import React, { useEffect, useRef } from 'react'

import { handleMouseLeave, handleMouseMove } from './utils'

type TiltProps = {
    children: React.ReactNode
    maxTilt?: number
    scale?: number
    className?: string
}

export const Tilt = ({ children, maxTilt = 5, scale = 1.05, className = '' }: TiltProps): JSX.Element => {
    const containerRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        const el = containerRef.current
        if (el) {
            el.style.transform = `perspective(1000px) rotateX(0deg) rotateY(0deg) scale(1)`
            el.style.transition = 'transform 0.2s ease-out'
            el.style.transformStyle = 'preserve-3d'
            el.style.willChange = 'transform'
        }
    }, [])

    return (
        <div
            data-testid="tilt"
            ref={containerRef}
            className={className}
            onMouseMove={handleMouseMove(containerRef, maxTilt, scale)}
            onMouseLeave={handleMouseLeave(containerRef)}
        >
            {children}
        </div>
    )
}
